import { pipe, prop } from 'ramda'

const baseLayoutSelector = prop('layout')

export const appBarSelector = pipe(baseLayoutSelector, prop('appBar'))

export const appBarShowSelector = pipe(appBarSelector, prop('show'))

